export default "__VITE_ASSET__DwTZn$FN__"